import { render, staticRenderFns } from "./DynamicTelemetryCard.vue?vue&type=template&id=587cf8be&scoped=true&"
import script from "./DynamicTelemetryCard.vue?vue&type=script&lang=ts&"
export * from "./DynamicTelemetryCard.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicTelemetryCard.vue?vue&type=style&index=0&id=587cf8be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587cf8be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
